<app-layout-header *ngIf="!layoutService.isEmbed"></app-layout-header>
<div id="layout-content">
  <router-outlet></router-outlet>
</div>
<app-layout-footer *ngIf="!layoutService.isEmbed"></app-layout-footer>

<app-layout-symbols></app-layout-symbols>
